export const LOCAL_STORAGE_KEY = 'DI_CCDP';
export const errorPrefix = 'DI CCDP :: Failed to get from local storage;';
/**
 * Abstraction to set data on the `LOCAL_STORAGE_KEY` key in local storage.
 */
export function getStorage() {
    try {
        const rawData = window.localStorage.getItem(LOCAL_STORAGE_KEY);
        if (rawData === null) {
            return {};
        }
        return JSON.parse(rawData);
    }
    catch (err) {
        console.error(`${errorPrefix} ${err}`);
        return {};
    }
}
/**
 * Abstraction to patch data on the `LOCAL_STORAGE_KEY` key in local storage.
 * Will only overwrite the existing storage for only the keys provided on the
 * parameter.
 */
export function patchStorage(data) {
    try {
        const currentStorage = getStorage();
        const newData = { ...currentStorage, ...data };
        const stringifiedData = JSON.stringify(newData);
        window.localStorage.setItem(LOCAL_STORAGE_KEY, stringifiedData);
    }
    catch (err) {
        console.error(`${errorPrefix} ${err}`);
    }
}
